const PlanDescription = {
  name: "Unique key for the plan",
  description: "The title of the plan",
  add_product: "Add product to override price",
  add_include: "Add include unit type",
  include_groups: "Plan or Services Include Groups",
  included_services: 'Services that are included in the plan',
};

export default PlanDescription;
